export default __webpack_public_path__ + "static/media/landing-blockimg1.57f490a9.jpg";